var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTitanmachine = function SvgTitanmachine(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 75.306442,
    x2: 86,
    y2: 96.932747,
    gradientTransform: "matrix(0.78125,0,0,0.78125,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 63.15625,
    y1: 18.8125,
    x2: 63.15625,
    y2: 154.966629,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 86.346687,
    y1: 18.8125,
    x2: 86.346687,
    y2: 154.966629,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 95.605133,
    y1: 18.8125,
    x2: 95.605133,
    y2: 154.966629,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 86.341309,
    y1: 18.8125,
    x2: 86.341309,
    y2: 154.966629,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 67.415939,
    y1: 18.8125,
    x2: 67.415939,
    y2: 154.966629,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 18.8125,
    x2: 86,
    y2: 154.966629,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 68.53125,
    y1: 18.8125,
    x2: 68.53125,
    y2: 154.966629,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9118239"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 28.125 25 C 28.125 26.726562 26.726562 28.125 25 28.125 C 23.273438 28.125 21.875 26.726562 21.875 25 C 21.875 23.273438 23.273438 21.875 25 21.875 C 26.726562 21.875 28.125 23.273438 28.125 25 Z M 28.125 25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 25 11.71875 C 17.675781 11.71875 11.71875 17.675781 11.71875 25 L 13.28125 25 C 13.28125 18.539062 18.539062 13.28125 25 13.28125 Z M 25 11.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 42 32.96875 C 40.554688 32.125 39.066406 31.25 36.101562 31.25 C 33.136719 31.25 31.644531 32.125 30.203125 32.96875 C 28.882812 33.742188 27.632812 34.476562 25.09375 34.476562 C 22.558594 34.476562 21.3125 33.746094 19.992188 32.96875 C 18.550781 32.125 17.058594 31.25 14.097656 31.25 C 11.132812 31.25 9.644531 32.125 8.199219 32.96875 C 6.878906 33.742188 5.632812 34.476562 3.09375 34.476562 L 3.09375 36.039062 C 6.058594 36.039062 7.550781 35.164062 8.992188 34.316406 C 10.3125 33.542969 11.558594 32.8125 14.097656 32.8125 C 16.632812 32.8125 17.882812 33.542969 19.199219 34.316406 C 20.644531 35.164062 22.132812 36.039062 25.09375 36.039062 C 28.058594 36.039062 29.550781 35.164062 30.992188 34.316406 C 32.3125 33.542969 33.5625 32.8125 36.101562 32.8125 C 38.640625 32.8125 39.886719 33.542969 41.207031 34.320312 C 42.652344 35.164062 44.144531 36.039062 47.105469 36.039062 L 47.105469 34.476562 C 44.566406 34.476562 43.320312 33.742188 42 32.96875 Z M 42 32.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 36.101562 34.375 C 33.136719 34.375 31.644531 35.25 30.203125 36.09375 C 28.882812 36.867188 27.632812 37.601562 25.09375 37.601562 C 22.558594 37.601562 21.3125 36.871094 19.992188 36.09375 C 18.550781 35.25 17.058594 34.375 14.097656 34.375 C 11.386719 34.375 9.890625 35.113281 8.480469 35.933594 L 9.261719 37.285156 C 10.53125 36.546875 11.769531 35.9375 14.097656 35.9375 C 16.632812 35.9375 17.882812 36.667969 19.199219 37.441406 C 20.644531 38.289062 22.132812 39.164062 25.09375 39.164062 C 28.058594 39.164062 29.550781 38.289062 30.992188 37.441406 C 32.3125 36.667969 33.5625 35.9375 36.101562 35.9375 C 38.640625 35.9375 39.886719 36.667969 41.207031 37.445312 C 42.652344 38.289062 44.144531 39.164062 47.105469 39.164062 L 47.105469 37.601562 C 44.566406 37.601562 43.320312 36.867188 42 36.09375 C 40.554688 35.25 39.066406 34.375 36.101562 34.375 Z M 36.101562 34.375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 25.09375 43.75 C 22.550781 43.75 21.304688 43.039062 19.980469 42.289062 C 18.542969 41.472656 17.054688 40.625 14.097656 40.625 L 14.097656 42.1875 C 16.640625 42.1875 17.890625 42.898438 19.210938 43.648438 C 20.648438 44.464844 22.140625 45.3125 25.09375 45.3125 C 28.050781 45.3125 29.542969 44.464844 30.984375 43.648438 C 32.304688 42.898438 33.554688 42.1875 36.101562 42.1875 L 36.101562 40.625 C 33.144531 40.625 31.652344 41.472656 30.210938 42.289062 C 28.890625 43.039062 27.640625 43.75 25.09375 43.75 Z M 25.09375 43.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 25.09375 40.726562 C 22.558594 40.726562 21.3125 39.996094 19.992188 39.21875 C 18.550781 38.375 17.058594 37.5 14.097656 37.5 C 11.132812 37.5 9.644531 38.375 8.199219 39.21875 C 6.878906 39.992188 5.632812 40.726562 3.09375 40.726562 L 3.09375 42.289062 C 6.058594 42.289062 7.550781 41.414062 8.992188 40.566406 C 10.3125 39.792969 11.558594 39.0625 14.097656 39.0625 C 16.632812 39.0625 17.882812 39.792969 19.199219 40.566406 C 20.644531 41.414062 22.132812 42.289062 25.09375 42.289062 C 28.058594 42.289062 29.550781 41.414062 30.992188 40.566406 C 32.3125 39.792969 33.5625 39.0625 36.101562 39.0625 L 36.101562 37.5 C 33.136719 37.5 31.644531 38.375 30.203125 39.21875 C 28.882812 39.992188 27.632812 40.726562 25.09375 40.726562 Z M 25.09375 40.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 6.25 28.125 L 8.902344 28.125 C 9.070312 28.988281 9.308594 29.835938 9.609375 30.652344 L 11.074219 30.109375 C 10.730469 29.183594 10.480469 28.210938 10.332031 27.226562 L 10.230469 26.5625 L 6.25 26.5625 C 6.25 24.839844 7.652344 23.4375 9.375 23.4375 L 10.230469 23.4375 L 10.332031 22.773438 C 10.691406 20.410156 11.636719 18.140625 13.058594 16.210938 L 13.460938 15.667969 L 12.847656 15.058594 C 11.628906 13.839844 11.628906 11.855469 12.847656 10.636719 L 15.667969 13.460938 L 16.210938 13.058594 C 18.140625 11.636719 20.410156 10.691406 22.773438 10.332031 L 23.4375 10.230469 L 23.4375 9.375 C 23.4375 7.652344 24.839844 6.25 26.5625 6.25 L 26.5625 10.230469 L 27.226562 10.332031 C 29.589844 10.691406 31.859375 11.636719 33.789062 13.058594 L 34.332031 13.460938 L 34.941406 12.847656 C 36.164062 11.628906 38.144531 11.628906 39.363281 12.847656 L 36.539062 15.667969 L 36.941406 16.210938 C 38.363281 18.140625 39.308594 20.410156 39.667969 22.773438 L 39.769531 23.4375 L 40.625 23.4375 C 42.347656 23.4375 43.75 24.839844 43.75 26.5625 L 39.769531 26.5625 L 39.667969 27.226562 C 39.523438 28.183594 39.28125 29.132812 38.949219 30.042969 L 40.417969 30.578125 C 40.707031 29.78125 40.9375 28.957031 41.097656 28.125 L 43.75 28.125 C 44.613281 28.125 45.3125 27.425781 45.3125 26.5625 C 45.3125 24.140625 43.464844 22.140625 41.101562 21.898438 C 40.683594 19.738281 39.824219 17.664062 38.585938 15.832031 L 40.46875 13.949219 C 41.078125 13.34375 41.078125 12.351562 40.46875 11.742188 C 38.753906 10.027344 36.027344 9.921875 34.1875 11.425781 C 32.359375 10.1875 30.285156 9.324219 28.125 8.902344 L 28.125 6.25 C 28.125 5.386719 27.421875 4.6875 26.5625 4.6875 C 24.136719 4.6875 22.136719 6.535156 21.898438 8.898438 C 19.738281 9.316406 17.664062 10.175781 15.832031 11.414062 L 13.949219 9.53125 C 13.339844 8.925781 12.347656 8.925781 11.742188 9.53125 C 10.027344 11.246094 9.921875 13.972656 11.425781 15.8125 C 10.183594 17.648438 9.316406 19.730469 8.898438 21.898438 C 6.535156 22.140625 4.6875 24.140625 4.6875 26.5625 C 4.6875 27.425781 5.386719 28.125 6.25 28.125 Z M 6.25 28.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 16.40625 25 C 16.40625 20.261719 20.261719 16.40625 25 16.40625 L 25 14.84375 C 19.398438 14.84375 14.84375 19.398438 14.84375 25 Z M 16.40625 25 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTitanmachine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/titanmachine.0376319e.svg";
export { ForwardRef as ReactComponent };